import React from "react";
import AdminMapMessages from "../components/AdminMapMessages/AdminMapMessages";

const AdminMapMessagesPage = () => {
  return <AdminMapMessages />;
};

export default AdminMapMessagesPage;
